
import { WorldCountry } from '../types';

export const bangladeshExpanded: WorldCountry = {
  name: 'Bangladesh',
  slug: 'bangladesh',
  code: 'BD',
  population: 164689383,
  topCities: [
    { name: 'Dhaka', slug: 'dhaka', population: 9540000 },
    { name: 'Chittagong', slug: 'chittagong', population: 2592439 },
    { name: 'Khulna', slug: 'khulna', population: 1022000 },
    { name: 'Rajshahi', slug: 'rajshahi', population: 700133 },
    { name: 'Sylhet', slug: 'sylhet', population: 526412 },
    { name: 'Rangpur', slug: 'rangpur', population: 343122 },
    { name: 'Barisal', slug: 'barisal', population: 328278 },
    { name: 'Comilla', slug: 'comilla', population: 389411 },
    { name: 'Mymensingh', slug: 'mymensingh', population: 389411 },
    { name: 'Narayanganj', slug: 'narayanganj', population: 2948217 },
    
    // Expansión: 90 ciudades adicionales
    { name: 'Gazipur', slug: 'gazipur', population: 1777429 },
    { name: 'Tongi', slug: 'tongi', population: 476475 },
    { name: 'Bogra', slug: 'bogra', population: 350397 },
    { name: 'Dinajpur', slug: 'dinajpur', population: 200543 },
    { name: 'Jessore', slug: 'jessore', population: 237478 },
    { name: 'Pabna', slug: 'pabna', population: 144477 },
    { name: 'Sirajganj', slug: 'sirajganj', population: 127481 },
    { name: 'Tangail', slug: 'tangail', population: 120309 },
    { name: 'Jamalpur', slug: 'jamalpur', population: 167900 },
    { name: 'Kushtia', slug: 'kushtia', population: 114293 },
    { name: 'Brahmanbaria', slug: 'brahmanbaria', population: 109032 },
    { name: 'Faridpur', slug: 'faridpur', population: 110154 },
    { name: 'Madaripur', slug: 'madaripur', population: 52281 },
    { name: 'Gopalganj', slug: 'gopalganj', population: 51817 },
    { name: 'Shariatpur', slug: 'shariatpur', population: 45648 },
    { name: 'Manikganj', slug: 'manikganj', population: 52441 },
    { name: 'Munshiganj', slug: 'munshiganj', population: 44218 },
    { name: 'Rajbari', slug: 'rajbari', population: 42484 },
    { name: 'Norail', slug: 'norail', population: 37366 },
    { name: 'Magura', slug: 'magura', population: 42457 },
    { name: 'Jhenaidah', slug: 'jhenaidah', population: 82531 },
    { name: 'Chuadanga', slug: 'chuadanga', population: 51917 },
    { name: 'Meherpur', slug: 'meherpur', population: 38749 },
    { name: 'Satkhira', slug: 'satkhira', population: 75316 },
    { name: 'Bagerhat', slug: 'bagerhat', population: 46000 },
    { name: 'Pirojpur', slug: 'pirojpur', population: 47000 },
    { name: 'Jhalokati', slug: 'jhalokati', population: 32000 },
    { name: 'Patuakhali', slug: 'patuakhali', population: 67000 },
    { name: 'Barguna', slug: 'barguna', population: 34000 },
    { name: 'Bhola', slug: 'bhola', population: 56000 },
    { name: 'Lakshmipur', slug: 'lakshmipur', population: 45000 },
    { name: 'Noakhali', slug: 'noakhali', population: 78000 },
    { name: 'Feni', slug: 'feni', population: 67000 },
    { name: 'Chandpur', slug: 'chandpur', population: 89000 },
    { name: 'Cox\'s Bazar', slug: 'coxs-bazar', population: 223522 },
    { name: 'Bandarban', slug: 'bandarban', population: 34000 },
    { name: 'Rangamati', slug: 'rangamati', population: 78000 },
    { name: 'Khagrachhari', slug: 'khagrachhari', population: 45000 },
    { name: 'Panchagarh', slug: 'panchagarh', population: 23000 },
    { name: 'Thakurgaon', slug: 'thakurgaon', population: 45000 },
    { name: 'Lalmonirhat', slug: 'lalmonirhat', population: 56000 },
    { name: 'Nilphamari', slug: 'nilphamari', population: 67000 },
    { name: 'Kurigram', slug: 'kurigram', population: 78000 },
    { name: 'Gaibandha', slug: 'gaibandha', population: 89000 },
    { name: 'Jaipurhat', slug: 'jaipurhat', population: 45000 },
    { name: 'Chapainawabganj', slug: 'chapainawabganj', population: 56000 },
    { name: 'Naogaon', slug: 'naogaon', population: 67000 },
    { name: 'Natore', slug: 'natore', population: 78000 },
    { name: 'Sherpur', slug: 'sherpur', population: 45000 },
    { name: 'Netrokona', slug: 'netrokona', population: 56000 },
    { name: 'Kishoreganj', slug: 'kishoreganj', population: 67000 },
    { name: 'Narsingdi', slug: 'narsingdi', population: 78000 },
    { name: 'Habiganj', slug: 'habiganj', population: 89000 },
    { name: 'Moulvibazar', slug: 'moulvibazar', population: 45000 },
    { name: 'Sunamganj', slug: 'sunamganj', population: 56000 },
    { name: 'Hobiganj', slug: 'hobiganj', population: 67000 },
    { name: 'Cumilla', slug: 'cumilla', population: 78000 },
    { name: 'Burichang', slug: 'burichang', population: 34000 },
    { name: 'Brahmanpara', slug: 'brahmanpara', population: 45000 },
    { name: 'Chandina', slug: 'chandina', population: 23000 },
    { name: 'Chauddagram', slug: 'chauddagram', population: 56000 },
    { name: 'Daudkandi', slug: 'daudkandi', population: 34000 },
    { name: 'Debidwar', slug: 'debidwar', population: 45000 },
    { name: 'Homna', slug: 'homna', population: 23000 },
    { name: 'Laksam', slug: 'laksam', population: 67000 },
    { name: 'Muradnagar', slug: 'muradnagar', population: 45000 },
    { name: 'Nangalkot', slug: 'nangalkot', population: 34000 },
    { name: 'Monohorgonj', slug: 'monohorgonj', population: 23000 },
    { name: 'Meghna', slug: 'meghna', population: 45000 },
    { name: 'Titas', slug: 'titas', population: 34000 },
    { name: 'Barura', slug: 'barura', population: 23000 },
    { name: 'Matlab', slug: 'matlab', population: 56000 },
    { name: 'Kachua', slug: 'kachua', population: 34000 },
    { name: 'Shahrasti', slug: 'shahrasti', population: 45000 },
    { name: 'Hajiganj', slug: 'hajiganj', population: 23000 },
    { name: 'Haimchar', slug: 'haimchar', population: 67000 },
    { name: 'Matlab Dakshin', slug: 'matlab-dakshin', population: 45000 },
    { name: 'Matlab Uttar', slug: 'matlab-uttar', population: 34000 },
    { name: 'Sarail', slug: 'sarail', population: 23000 },
    { name: 'Ashuganj', slug: 'ashuganj', population: 56000 },
    { name: 'Akhaura', slug: 'akhaura', population: 34000 },
    { name: 'Nabinagar', slug: 'nabinagar', population: 45000 },
    { name: 'Nasirnagar', slug: 'nasirnagar', population: 23000 },
    { name: 'Bancharampur', slug: 'bancharampur', population: 67000 },
    { name: 'Bijoynagar', slug: 'bijoynagar', population: 45000 },
    { name: 'Kasba', slug: 'kasba', population: 34000 },
    { name: 'Akbarpur', slug: 'akbarpur', population: 23000 },
    { name: 'Sultanpur', slug: 'sultanpur-bd', population: 56000 },
    { name: 'Chhagalnaiya', slug: 'chhagalnaiya', population: 34000 },
    { name: 'Daganbhuiyan', slug: 'daganbhuiyan', population: 45000 },
    { name: 'Parshuram', slug: 'parshuram', population: 23000 }
  ]
};
